'use es6';

import { RepChatAssignmentCardContent, RepChatAssignmentCardTitle } from './components/card/RepChatAssignmentCard';
export { RepChatAssignmentCardContent, RepChatAssignmentCardTitle };